import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IGatewayResponse } from '@/Module/Core/Model/ApiModel';
import type { IPaginationRequest } from '@/Module/Core/Model/DataModel';
import type { IGetLessonListByCourseIdQuery } from '@/Module/Lesson/Model/ApiModel';
import type { ILessonSection } from '@/Module/Lesson/Model/DataModel';
import { LessonService } from '@/Module/Lesson/Service';
import type { IState } from '@/Module/Store/Model';

export const getLessonListByCourseIdAction = createAsyncThunk<
  IGatewayResponse<ILessonSection[]>,
  Omit<IGetLessonListByCourseIdQuery, keyof IPaginationRequest>
>('lesson/getListByCourseId', (req, { signal, getState }) => {
  return LessonService.getListByCourseId(
    {
      ...req,
      pageNo: (getState() as IState).lessonSection.page,
      pageCount: (getState() as IState).lessonSection.rows,
    },
    signal,
  ).then(({ data }) => data);
});
